(() => {
  const TIP_DATA = {
    bust: {
      label: "Bust:",
      description:
        "Wear the bra you will be wearing with the dress, and pull the tape across the fullest part of the bust.",
    },
    waist: {
      label: "Waist:",
      description:
        "Bend to one side to find the crease, that's your natural waist. Pull tape across the narrowest part and keep tape slightly loose to allow for breathing room.",
    },
    hips: {
      label: "Hips:",
      description:
        "Stand straight and pull tape across the widest part of the hips and rear.",
    },
    htf: {
      label: "Hollow to Floor:",
      description:
        "Stand straight with bare feet together and measure from the center of the collarbone to the floor.",
    },
    height: {
      label: "Height (Bare Foot):",
      description:
        "Stand straight with bare feet together and measure from the top of the head to the floor.",
    },
  };

  const REQUIRED_FIELDS = ["bust", "waist", "hips", "htf", "height"];

  let activeConfig = null;

  function loadConfig() {
    const node = document.getElementById("quick-add-custom-size-config");
    if (!node) return { images: {}, returnPolicyUrl: "" };

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.error("Quick add custom size config parse failed:", error);
      return { images: {}, returnPolicyUrl: "" };
    }
  }

  function isCustomSizeValue(value) {
    const normalized = String(value || "").trim();
    if (!normalized) return false;
    return (
      normalized === "Custom Size" ||
      normalized === "Custom size" ||
      normalized.indexOf("Custom Size") === 0
    );
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function getPanel(scope) {
    return scope?.querySelector?.("[data-qa-custom-size-panel]") || null;
  }

  function getPanelRoot(scope) {
    return getPanel(scope);
  }

  function renderField(key, label, config) {
    const imageUrl = config?.images?.[key] || "";
    const tooltipMarkup = imageUrl
      ? `<div class="unit-tooltip-content">
          <p>How to properly measure your ${escapeHtml(label.toLowerCase())}?</p>
          <img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(label)} guide" width="280" height="auto" loading="lazy">
        </div>`
      : "";

    return `
      <div class="customsize-row qa-customsize-row" data-qa-custom-row="${key}">
        <div class="j-flex">
          <div class="name">${escapeHtml(label)}</div>
          <div class="input-text">
            <input
              type="number"
              class="text-custome-size-item-required qa-customsize-input"
              data-qa-custom-field="${key}"
              placeholder=""
              min="0"
              step="0.1"
              inputmode="decimal"
              aria-label="${escapeHtml(label)}"
            >
            <div class="customsize-unit-text qa-customsize-unit-text">
              (<span class="unit-value" data-qa-unit-label>in</span>)
              ${
                tooltipMarkup
                  ? `<span class="unit-tooltip qa-customsize-unit-tooltip" tabindex="0" aria-label="${escapeHtml(
                      label,
                    )} measurement guide">?${tooltipMarkup}</span>`
                  : ""
              }
            </div>
          </div>
        </div>
      </div>
    `;
  }

  function renderPanel(config = {}) {
    activeConfig = config;
    const guideImage = config.guideImage || "";
    const guideZoomImage = config.guideZoomImage || guideImage;
    const bustImage = config?.images?.bust || "";
    const returnPolicyUrl =
      config.returnPolicyUrl ||
      "https://www.kissprom.com/pages/refund-return-policy";

    return `
      <div class="quick-add-ajax__custom-size-root" data-qa-custom-size-root>
        <div class="quick-add-ajax__custom-size customizebox qa-customsize-panel" data-qa-custom-size-panel hidden>
          <div class="form-div customsize-ui qa-customsize-ui">
            <input type="hidden" data-qa-custom-unit value="in">
            <div class="customsize-unit-switch" data-qa-unit-switch data-unit="in" role="group" aria-label="Measurement unit switch">
              <span class="customsize-unit-label is-active" data-unit="in">IN</span>
              <label class="customsize-unit-toggle" aria-label="Toggle unit">
                <input type="checkbox" class="customsize-unit-toggle__input" data-qa-unit-toggle aria-label="Switch between inches and centimeters">
                <span class="customsize-unit-toggle__track" aria-hidden="true">
                  <span class="customsize-unit-toggle__dot"></span>
                </span>
              </label>
              <span class="customsize-unit-label" data-unit="cm">CM</span>
            </div>
            <div class="customsize-tip qa-customsize-tip-desktop" data-qa-custom-tip>
              <div data-qa-custom-tip-content>
                <span class="tip-label">${escapeHtml(TIP_DATA.bust.label)}</span>
                <span class="tip-description">${escapeHtml(TIP_DATA.bust.description)}</span>
              </div>
            </div>
            <div class="customsize-layout qa-customsize-layout">
              <div class="customsize-form-list">
                ${renderField("bust", "Bust:", config)}
                ${renderField("waist", "Waist:", config)}
                ${renderField("hips", "Hips:", config)}
                ${renderField("htf", "Hollow to Floor:", config)}
                ${renderField("height", "Height (Bare Foot):", config)}
              </div>
              <div class="customsize-tip qa-customsize-tip-mobile">
                <div data-qa-custom-tip-content-mobile>
                  <p>
                    <span class="tip-label">${escapeHtml(TIP_DATA.bust.label)}</span>
                    <span class="tip-description">${escapeHtml(TIP_DATA.bust.description)}</span>
                  </p>
                </div>
                <div class="qa-customsize-tip-image-wrap" data-qa-custom-tip-image-wrap>
                  ${
                    bustImage
                      ? `<img data-qa-custom-tip-image src="${escapeHtml(
                          bustImage,
                        )}" alt="Measurement guide" loading="lazy">`
                      : ""
                  }
                </div>
              </div>
              ${
                guideImage
                  ? `<div class="customsize-guide-image-wrap qa-customsize-guide">
                      <img src="${escapeHtml(guideImage)}" alt="Size Guide" width="100%" height="auto" loading="lazy">
                      <button type="button" class="customsize-zoom-trigger" data-qa-custom-zoom-open aria-label="Open size guide detail">
                        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                          <path d="M10.5 3a7.5 7.5 0 0 1 5.92 12.1l4.24 4.25a1 1 0 0 1-1.42 1.41l-4.24-4.24A7.5 7.5 0 1 1 10.5 3Zm0 2a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Zm-1 2.5a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Z" fill="currentColor"/>
                        </svg>
                      </button>
                    </div>`
                  : ""
              }
            </div>
            <div class="customsize-checkbox-p qa-customsize-policy">
              <label class="filter-group__item" data-tag="customsize">
                <input class="filter-group__checkbox qa-customsize-policy-input" type="checkbox" data-qa-custom-policy checked tabindex="-1" aria-readonly="true">
                <span class="filter-group__item__text">
                  <a href="${escapeHtml(returnPolicyUrl)}" target="_blank" rel="noopener" title="Return Policy">I have read and agreed to the cancellation, exchange and return policy for custom-sized products.</a>
                </span>
                <span>
                  <div class="custompolicy">Customize item is final sale, not applicable for free try at home and return and exchange.</div>
                </span>
              </label>
            </div>
          </div>
          ${
            guideZoomImage
              ? `<div class="customsize-zoom-modal qa-customsize-zoom" data-qa-custom-zoom-modal aria-hidden="true">
                  <div class="customsize-zoom-modal__backdrop" data-qa-custom-zoom-close></div>
                  <div class="customsize-zoom-modal__dialog" role="dialog" aria-modal="true" aria-label="Size guide enlarged image">
                    <button type="button" class="customsize-zoom-modal__close" data-qa-custom-zoom-close aria-label="Close zoom image">&times;</button>
                    <img src="${escapeHtml(guideZoomImage)}" alt="Size Guide Detail" width="100%" height="auto" loading="lazy">
                  </div>
                </div>`
              : ""
          }
        </div>
      </div>
    `;
  }

  function setUnit(panel, unit) {
    if (!panel) return;

    const next = unit === "cm" ? "cm" : "in";
    const switchNode = panel.querySelector("[data-qa-unit-switch]");
    const hiddenUnit = panel.querySelector("[data-qa-custom-unit]");
    const toggle = panel.querySelector("[data-qa-unit-toggle]");

    if (switchNode) {
      switchNode.dataset.unit = next;
      switchNode.querySelectorAll(".customsize-unit-label").forEach((label) => {
        label.classList.toggle("is-active", label.dataset.unit === next);
      });
    }

    if (hiddenUnit) hiddenUnit.value = next;
    if (toggle) toggle.checked = next === "cm";

    panel.querySelectorAll("[data-qa-unit-label]").forEach((label) => {
      label.textContent = next;
    });
  }

  function updateTip(panel, key, config = activeConfig || loadConfig()) {
    const data = TIP_DATA[key];
    if (!panel || !data) return;

    panel.querySelectorAll("[data-qa-custom-tip-content], [data-qa-custom-tip-content-mobile]").forEach((tipContent) => {
      const labelNode = tipContent.querySelector(".tip-label");
      const descriptionNode = tipContent.querySelector(".tip-description");

      if (labelNode) labelNode.textContent = data.label;
      if (descriptionNode) descriptionNode.textContent = data.description;
    });

    const tipImage = panel.querySelector("[data-qa-custom-tip-image]");
    const imageUrl = config?.images?.[key] || "";
    if (tipImage && imageUrl) {
      tipImage.src = imageUrl;
      tipImage.alt = `${data.label} measurement guide`;
    }
  }

  function clearPanelFields(panel) {
    if (!panel) return;

    panel.querySelectorAll("[data-qa-custom-field]").forEach((input) => {
      input.value = "";
      input.classList.remove("customsize-input-error");
    });

    const policy = panel.querySelector("[data-qa-custom-policy]");
    if (policy) policy.checked = true;

    setUnit(panel, "in");
    updateTip(panel, "bust");
    closeZoom(panel);
  }

  function toggleVisibility(scope, show) {
    const panel = getPanel(scope);
    if (!panel) return;

    panel.hidden = !show;

    if (!show) {
      clearPanelFields(panel);
    } else {
      lockPolicyCheckbox(panel);
    }
  }

  function collectPropertiesFromPanel(panel) {
    if (!panel || panel.hidden) return {};

    const properties = {};
    const unit = panel.querySelector("[data-qa-custom-unit]")?.value || "in";
    properties["Measurement unit"] = unit;

    REQUIRED_FIELDS.forEach((key) => {
      const input = panel.querySelector(`[data-qa-custom-field="${key}"]`);
      if (!input?.value) return;

      const propertyKey =
        key === "htf" ? "HTF" : key.charAt(0).toUpperCase() + key.slice(1);
      properties[propertyKey] = String(input.value).trim();
    });

    return properties;
  }

  function validatePanelFields(panel, { requirePolicy = true } = {}) {
    if (!panel || panel.hidden) {
      return { valid: true, properties: {} };
    }

    let firstInvalid = null;

    REQUIRED_FIELDS.forEach((key) => {
      const input = panel.querySelector(`[data-qa-custom-field="${key}"]`);
      if (!input) return;

      const isEmpty = !input.value || !String(input.value).trim();
      input.classList.toggle("customsize-input-error", isEmpty);

      if (isEmpty && !firstInvalid) {
        firstInvalid = input;
      }
    });

    const policy = panel.querySelector("[data-qa-custom-policy]");
    if (requirePolicy && policy) {
      policy.checked = true;
    }

    if (firstInvalid) {
      firstInvalid.focus({ preventScroll: true });
      firstInvalid.scrollIntoView({ behavior: "smooth", block: "nearest" });
      return {
        valid: false,
        message: "Please fill in all required custom size measurements.",
        firstInvalid,
      };
    }

    return {
      valid: true,
      properties: collectPropertiesFromPanel(panel),
    };
  }

  function collectProperties(scope) {
    return collectPropertiesFromPanel(getPanel(scope));
  }

  function validate(scope) {
    return validatePanelFields(getPanel(scope));
  }

  function clear(scope) {
    toggleVisibility(scope, false);
  }

  function closeZoom(panel) {
    const modal = panel?.querySelector("[data-qa-custom-zoom-modal]");
    if (!modal) return;
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
  }

  function lockPolicyCheckbox(panel) {
    const policy = panel?.querySelector("[data-qa-custom-policy]");
    if (!policy) return;

    policy.checked = true;
  }

  function handlePolicyInteraction(event, panel) {
    const policy = panel.querySelector("[data-qa-custom-policy]");
    if (!policy) return false;

    if (event.target.matches("[data-qa-custom-policy]")) {
      event.preventDefault();
      policy.checked = true;
      return true;
    }

    const policyBlock = event.target.closest(".qa-customsize-policy");
    if (
      policyBlock &&
      !event.target.closest("a") &&
      (event.type === "click" || event.type === "change")
    ) {
      policy.checked = true;
      return true;
    }

    return false;
  }

  function handlePanelInteraction(event, scope) {
    const panel = getPanel(scope);
    if (!panel || !panel.contains(event.target)) return false;

    if (handlePolicyInteraction(event, panel)) {
      return true;
    }

    const unitToggle = event.target.closest("[data-qa-unit-toggle]");
    if (unitToggle) {
      setUnit(panel, unitToggle.checked ? "cm" : "in");
      return true;
    }

    const field = event.target.closest("[data-qa-custom-field]");
    if (field) {
      if (event.type === "focus" || event.type === "focusin") {
        updateTip(panel, field.dataset.qaCustomField);
      }

      if (event.type === "input" && field.value && String(field.value).trim()) {
        field.classList.remove("customsize-input-error");
      }

      return true;
    }

    if (event.target.closest("[data-qa-custom-zoom-open]")) {
      event.preventDefault();
      const modal = panel.querySelector("[data-qa-custom-zoom-modal]");
      if (modal) {
        modal.classList.add("is-open");
        modal.setAttribute("aria-hidden", "false");
      }
      return true;
    }

    if (event.target.closest("[data-qa-custom-zoom-close]")) {
      event.preventDefault();
      closeZoom(panel);
      return true;
    }

    return false;
  }

  window.QuickAddCustomSize = {
    loadConfig,
    renderPanel,
    isCustomSizeValue,
    getPanelRoot,
    toggleVisibility,
    clear,
    validate,
    collectProperties,
    handlePanelInteraction,
    closeZoom,
  };
})();
